// @flow
import * as React from 'react';
import LoginFormContainer from 'containers/LoginFormContainer';
import CenteredLayout from '../layouts/CenteredLayout';

const LoginPage = ({
  onLogin,
  redirectTo,
  email,
  inviteId,
  savedListing,
  subscribedSubsite,
  title
}: {
  onLogin: Function,
  redirectTo: ?string,
  email: ?string,
  inviteId: ?string,
  savedListing: ?Object,
  subscribedSubsite: ?string,
  title?: string
}) => (
  <CenteredLayout
    title={/* TRANSLATORS: login page title */ title || getText('Log In')}
  >
    <LoginFormContainer
      isModal={false}
      redirectTo={redirectTo}
      email={email}
      inviteId={inviteId}
      savedListing={savedListing}
      subscribedSubsite={subscribedSubsite}
      onLogin={onLogin}
    />
  </CenteredLayout>
);

export default LoginPage;
